// extracted by mini-css-extract-plugin
export default {"container":"YtThumbnail_container__0J-Jf","image":"YtThumbnail_image__EJT0X","ytButton":"YtThumbnail_ytButton__exvlr"};